import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";

import { GET_SELLER_BRANDING } from "routes/private/apollo/queries";
import { baseHelper } from "lib/helpers";
import { Text } from "@shopify/polaris";
import StyledChart, { ReportTitle } from "./chartPDFStyle";

const Header = (props) => {
  const { setLogo, header } = props;
  const [bandData, setBrandData] = useState({});
  const today = new Date().toLocaleDateString();
  const { data: brandingData, loading: isLoading } = useQuery(GET_SELLER_BRANDING);
  const responseData = baseHelper.getResponseData(brandingData, "getSellerBranding");

  useEffect(() => {
    if (!isLoading && responseData) {
      setBrandData(responseData);
      setLogo(!!responseData.logo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, responseData]);

  return (
    (header && (
      <div>
        <StyledChart>
          {bandData.logo ? (
            <img src={bandData.logo} className="brand-logo" id="tableBanner" alt="brandLogo" />
          ) : (
            <div className="brand-name">
              <Text as="span" variant="bodyLg">
                {baseHelper.ucFirst(bandData.brandName)}
              </Text>
            </div>
          )}
          <Text variant="headingLg" as="p">{`Export Date :${today}`}</Text>
        </StyledChart>
        <ReportTitle className="report">
          <Text variant="headingLg" as="p">
            Analytics Report
          </Text>
        </ReportTitle>
      </div>
    )) ||
    null
  );
};

export default Header;
